export const translations = {
  /* ---------------- ITALIANO ---------------- */
  it: {
    topbar: {
      hours: "Lun – Ven · 9:00 – 19:00 · Su appuntamento",
    },
    nav: {
      studio: "Lo Studio",
      aree: "Aree di Attività",
      team: "Il Team",
      sede: "La Sede",
      metodo: "Il Metodo",
      contatti: "Contatti",
      news: "News",
      cta: "Richiedi Consulenza",
    },
    hero: {
      overline: "Società tra Avvocati · Manduria",
      line1: "Eccellenza giuridica.",
      line2: "Rigore strategico.",
      sub: "Consulenza e difesa, per privati ed imprese, con un unico standard: la massima preparazione, il massimo rispetto per chi si rivolge a noi.",
      cta1: "Richiedi una consulenza",
      cta2: "Le aree di attività",
      badges: ["Diritto Civile e Familiare", "Diritto Penale", "Diritto Societario"],
      scroll: "Scorri",
    },
    marquee: [
      "Diritto Civile",
      "Diritto di Famiglia",
      "Diritto Penale",
      "Diritto Societario e M&A",
      "Diritto Immobiliare",
      "Recupero Crediti",
      "Protezione Patrimoniale",
    ],
    aree: {
      overline: "Le nostre competenze",
      title: "Aree di attività",
      intro: "Sei discipline, un solo metro di misura: la cura ossessiva del dettaglio e la strategia costruita attorno al tuo caso.",
      imgCaption: "Radici a Manduria, sguardo sull'intera Italia.",
      cards: {
        civile: {
          title: "Diritto Civile e Familiare",
          desc: "Tutela dei rapporti patrimoniali e personali con un approccio umano e risolutivo.",
          items: ["Separazione e divorzio", "Successioni ereditarie", "Contratti e responsabilità civile", "Tutela dei minori"],
        },
        penale: {
          title: "Diritto Penale",
          desc: "Difesa tecnica rigorosa in ogni fase del procedimento, dall'indagine al giudizio.",
          items: ["Difesa penale d'impresa", "Reati societari e fallimentari", "Assistenza durante gli interrogatori", "Ricorsi in Cassazione"],
        },
        societario: {
          title: "Diritto Societario e M&A",
          desc: "Consulenza strutturata per imprese, fondatori e investitori.",
          items: ["Fusioni e acquisizioni", "Patti parasociali", "Governance e statuti", "Transazioni commerciali"],
        },
        immobiliare: {
          title: "Diritto Immobiliare",
          desc: "Assistenza completa su operazioni immobiliari residenziali e strategiche.",
          items: ["Compravendite e locazioni", "Contenzioso condominiale", "Concessioni urbanistiche", "Due diligence"],
        },
        crediti: {
          title: "Recupero Crediti ed Esecuzioni",
          desc: "Strategie rapide e incisive per la tutela del credito, anche transfrontaliera.",
          items: ["Decreto ingiuntivo", "Pignoramenti", "Opposizioni ed esecuzioni", "Accordi transattivi"],
        },
        patrimonio: {
          title: "Protezione Patrimoniale",
          desc: "Architettura giuridica per preservare il patrimonio familiare e d'impresa.",
          items: ["Fondazioni e trust", "Patti di famiglia", "Pianificazione successoria", "Asset protection"],
        },
      },
    },
    studio: {
      overline: "Lo Studio",
      title: "La competenza nasce dall'ascolto.",
      p1: "Lo Studio Legale Legalia Società tra Avvocati è una società tra avvocati con sede a Manduria, in provincia di Taranto. Operiamo su tutto il territorio nazionale affiancando privati e imprese con un principio semplice: dietro ogni pratica c'è una persona, o un'impresa, che ha bisogno di certezze. Per questo costruiamo la strategia a partire dal vostro obiettivo, non dai formalismi.",
      p2: "Un team ristretto e selezionato, professionisti che seguono personalmente ogni incarico e una rete di corrispondenti in tutta Italia: la struttura di una boutique, la capacità di una realtà consolidata.",
      values: [
        { title: "Trasparenza", desc: "Ogni onorario, ogni tempistica, ogni rischio: chiaro dall'inizio, senza sorprese." },
        { title: "Deontologia", desc: "Riservatezza assoluta e rigore etico come fondamento irrinunciabile del nostro operato." },
        { title: "Determinazione", desc: "Ogni incarico è seguito personalmente dagli avvocati dello Studio, con incisività negoziale e processuale." },
      ],
      stripLabel: "I soci dello Studio",
    },
    team: {
      overline: "Le persone",
      title: "Il Team dello Studio",
      intro: "Tre soci, tre partner e due segretarie: un'unica direzione, la tutela rigorosa degli interessi di chi si rivolge a noi.",
      competenze: "Aree di competenza",
      attivita: "Attività",
      roles: { Socio: "Socio", Partner: "Partner", Segreteria: "Segreteria" },
      contact: "Scrivi allo Studio",
      members: {
        "giuseppe-brunetti": {
          items: ["Diritto penale", "Diritto di famiglia", "Successioni"],
          bio: "Da venticinque anni si occupa di diritto familiare e penale, nonché di successioni e patti di famiglia.",
        },
        "vincenzo-simone-depasquale": {
          items: ["Diritto del lavoro", "Diritto tributario e fiscale"],
          bio: "Già direttore di un primario gruppo imprenditoriale nel settore agroalimentare, è a capo del dipartimento immobiliare, fiscale, tributario e giuslavoristico, assistendo privati ed imprese anche nell'analisi dei bilanci e dei rapporti con fornitori e lavoratori.",
        },
        "francesco-del-prete": {
          items: ["Diritto bancario e finanziario", "Diritto pensionistico"],
          bio: "Esperto di diritto bancario e finanziario, assiste privati ed imprese; esperto anche in diritto previdenziale pubblico, assistendo gli interessati nel riconoscimento della causa di servizio ed i conseguenti benefici.",
        },
        "michela-sansonetti": {
          items: ["Recupero crediti", "Responsabilità extracontrattuale"],
        },
        "marika-antonucci": {
          items: ["Diritto bancario", "Infortunistica"],
        },
        "valeria-mustica": {
          items: ["Diritto condominiale", "Diritto patrimoniale"],
        },
        "luisiana-forleo": {
          items: ["Segreteria", "Rapporti con i clienti", "Preparazione del fascicolo"],
        },
        "eleonora-calo": {
          items: ["Segreteria", "Rapporti con i clienti", "Preparazione del fascicolo"],
        },
      },
    },
    metodo: {
      overline: "Il nostro metodo",
      title: "Un percorso chiaro, dall'ascolto alla soluzione.",
      steps: [
        { title: "Ascolto e valutazione", desc: "Primo incontro conoscitivo: analizziamo la posizione, i documenti e gli obiettivi, senza impegno." },
        { title: "Strategia tailor-made", desc: "Definiamo il piano d'azione, i tempi, i costi e le probabilità di successo in modo trasparente." },
        { title: "Azione e negoziazione", desc: "Azione legale o negoziazione diretta: scegliamo la via più efficiente per il risultato, sempre seguita dagli avvocati dello Studio." },
        { title: "Monitoraggio e risoluzione", desc: "Aggiornamenti costanti e trasparenti finché la soluzione — giudiziale o transattiva — non è raggiunta." },
      ],
    },
    news: {
      overline: "News giuridiche",
      title: "Aggiornamenti legali",
      intro: "Le analisi dello Studio su norme, riforme e sentenze che toccano privati e imprese.",
      readMore: "Leggi l'aggiornamento",
      empty: "Gli aggiornamenti legali dello Studio arriveranno a breve.",
      emptyHint: "Stiamo preparando i primi articoli: torna a trovarci.",
    },
    sede: {
      overline: "I nostri uffici",
      title: "Il Salone",
      text: "Uno spazio storico nel cuore di Manduria, dove ogni pratica viene discussa a tu per tu con l'avvocato che la segue.",
      caption: "Piazza Vittorio Emanuele II, 20/c · Manduria (TA)",
      cta: "Vieni a conoscerci",
      galleryLabel: "Scorci del territorio",
      gallery: [
        "Chiesa Madre · Piazza Vittorio Emanuele II",
        "Monumento ai Caduti",
        "Piazza Garibaldi",
        "Villa Comunale",
        "Le Dune della Litoranea",
        "Mura Messapiche",
      ],
    },
    contatti: {
      overline: "Contatti",
      title: "Parliamone.",
      intro: "Il primo incontro conoscitivo è senza impegno e serve a capire insieme se siamo lo studio giusto per te. Prenota un appuntamento: riceverai una email di riepilogo e ti confermeremo la data al più presto.",
      labels: { studio: "Studio", phone: "Telefono", whatsapp: "WhatsApp", emailpec: "Email / PEC", hours: "Orari" },
      areas: ["Diritto Civile e Familiare", "Diritto Penale", "Diritto Societario e M&A", "Diritto Immobiliare", "Recupero Crediti ed Esecuzioni", "Protezione Patrimoniale", "Altro"],
      form: {
        nome: "Nome e cognome *",
        nomePh: "Mario Rossi",
        email: "Email *",
        emailPh: "mario.rossi@email.it",
        telefono: "Telefono",
        telefonoPh: "+39 ...",
        area: "Area di interesse *",
        areaPh: "Seleziona…",
        data: "Data preferita *",
        ora: "Orario preferito *",
        messaggio: "Messaggio *",
        messaggioPh: "Descrivi brevemente il tuo caso: verrà trattato in via riservata.",
        privacyA: "informativa privacy",
        privacyPre: "Ho letto l'",
        privacyPost: " e acconsento al trattamento dei miei dati personali ai sensi del Reg. UE 2016/679 (GDPR). *",
        submit: "Prenota l'appuntamento",
        sending: "Invio in corso…",
      },
      errors: {
        nome: "Inserisci il tuo nome",
        email: "Inserisci un'email valida",
        area: "Seleziona un'area",
        data: "Scegli una data",
        dataWeekend: "Lo studio riceve dal lunedì al venerdì",
        ora: "Scegli un orario",
        messaggio: "Raccontaci brevemente il tuo caso (min. 10 caratteri)",
        consenso: "È necessario accettare l'informativa",
      },
      toasts: {
        checkTitle: "Controlla i campi evidenziati",
        checkDesc: "Alcuni dati sono mancanti o non validi.",
        okTitle: "Richiesta inviata correttamente",
        okDesc: "Ti abbiamo inviato una email di riepilogo: ti ricontatteremo per confermare l'appuntamento.",
        failTitle: "Invio non riuscito",
        failDesc: "Riprova tra qualche istante oppure scrivici via PEC.",
        failDescFix: "Correggi e riprova.",
      },
    },
    footer: {
      about: "Società tra avvocati con sede a Manduria (TA): consulenza legale in materia civile, penale, societaria e immobiliare.",
      nav: "Navigazione",
      contatti: "Contatti",
      legal: "Tutti i diritti riservati. Le informazioni su questo sito hanno finalità puramente divulgative e non costituiscono consulenza legale.",
      privacy: "Privacy Policy",
      admin: "Gestione Appuntamenti",
    },
    privacy: {
      overline: "Informativa al pubblico",
      title: "Privacy Policy",
      back: "Torna alla Home",
      updated: "Informativa sul trattamento dei dati personali ai sensi del Reg. UE 2016/679 (GDPR) · Ultimo aggiornamento: 30 settembre 2026",
      sections: [
        { title: "1. Titolare del trattamento", body: ["Il titolare del trattamento è Legalia Società tra Avvocati, con sede in Piazza Vittorio Emanuele II, 20/c · 74024 Manduria (TA), P.IVA 03451670735, indirizzo di posta elettronica certificata legalia@pec.it (\"il Titolare\")."] },
        { title: "2. Dati trattati", body: ["Attraverso il modulo di contatto del sito vengono raccolti i seguenti dati personali forniti volontariamente dall'interessato: nome e cognome, indirizzo email, numero di telefono (facoltativo), area di interesse, data e orario dell'appuntamento richiesto e contenuto del messaggio.", "Non vengono trattate categorie particolari di dati ai sensi dell'art. 9 del Regolamento UE 2016/679, né dati di navigazione diversi dai cookie tecnici."] },
        { title: "3. Finalità e base giuridica", body: ["I dati sono trattati esclusivamente per rispondere alle richieste di contatto, informazioni e consulenza inviate tramite il modulo presente sul sito, nonché per inviare un promemoria dell'appuntamento confermato.", "La base giuridica del trattamento è l'esecuzione di misure precontrattuali su richiesta dell'interessato (art. 6, par. 1, lett. b) del Regolamento UE 2016/679).", "Il conferimento dei dati è facoltativo, ma necessario per poter dare seguito alle richieste inviate: in assenza dei dati contrassegnati come obbligatori non sarà possibile fornire risposta."] },
        { title: "4. Modalità del trattamento e conservazione", body: ["I dati sono trattati con strumenti informatici, secondo principi di correttezza, liceità e trasparenza e nel rispetto delle misure minime di sicurezza di cui all'art. 32 del Regolamento.", "I dati sono conservati per il tempo strettamente necessario a gestire la richiesta ricevuta e, comunque, non oltre il periodo previsto dalle norme applicabili; l'interessato può in ogni momento chiederne la cancellazione."] },
        { title: "5. Comunicazione e diffusione dei dati", body: ["I dati raccolti non sono diffusi e non vengono ceduti a terzi per finalità di marketing. Sono accessibili ai soli soggetti autorizzati del Titolare incaricati del trattamento e possono essere comunicati nei casi previsti dalla legge.", "Per gestire le richieste ricevute, i dati possono essere inoltrati via posta elettronica all'indirizzo di posta elettronica del Titolare indicato al punto 1."] },
        { title: "6. Diritti dell'interessato", body: ["L'interessato può esercitare in ogni momento i diritti previsti dagli artt. 15-22 del Regolamento UE 2016/679: accesso ai dati, rettifica, cancellazione, limitazione del trattamento, portabilità dei dati, opposizione al trattamento.", "Ha inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it), qualora ritenga che il trattamento dei propri dati violi il Regolamento."] },
        { title: "7. Contatti", body: ["Per esercitare i propri diritti o per qualsiasi richiesta in materia di protezione dei dati personali è possibile contattare il Titolare scrivendo alla PEC legalia@pec.it oppure all'indirizzo email studiobdlex@gmail.com."] },
        { title: "8. Cookie", body: ["Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento delle pagine. Non vengono utilizzati cookie di profilazione né strumenti di tracciamento di terze parti."] },
        { title: "9. Avvertenza legale", body: ["Le informazioni contenute in questo sito hanno finalità puramente divulgative e non costituiscono consulenza legale né creano alcun rapporto professionale con l'utente."] },
      ],
    },
  },

  /* ---------------- ENGLISH ---------------- */
  en: {
    topbar: {
      hours: "Mon – Fri · 9:00 – 19:00 · By appointment",
    },
    nav: {
      studio: "The Firm",
      aree: "Practice Areas",
      team: "Our Team",
      sede: "Our Offices",
      metodo: "Our Method",
      contatti: "Contact",
      news: "News",
      cta: "Request a Consultation",
    },
    hero: {
      overline: "Law Firm · Manduria",
      line1: "Legal excellence.",
      line2: "Strategic rigour.",
      sub: "Counsel and defence, for individuals and businesses, with one single standard: the highest level of preparation, and the greatest respect for those who turn to us.",
      cta1: "Request a consultation",
      cta2: "Practice areas",
      badges: ["Civil & Family Law", "Criminal Law", "Corporate Law"],
      scroll: "Scroll",
    },
    marquee: [
      "Civil Law",
      "Family Law",
      "Criminal Law",
      "Corporate & M&A",
      "Real Estate Law",
      "Debt Recovery",
      "Asset Protection",
    ],
    aree: {
      overline: "Our expertise",
      title: "Practice areas",
      intro: "Six disciplines, one benchmark: obsessive attention to detail and a strategy built around your case.",
      imgCaption: "Rooted in Manduria, working across Italy.",
      cards: {
        civile: {
          title: "Civil & Family Law",
          desc: "Protecting personal and financial relationships with a human, results-driven approach.",
          items: ["Separation & divorce", "Inheritance & estates", "Contracts & civil liability", "Child custody & protection"],
        },
        penale: {
          title: "Criminal Law",
          desc: "Rigorous technical defence at every stage of the proceedings, from investigation to trial.",
          items: ["Business criminal defence", "Corporate & financial crime", "Interview & custody support", "Appeals before the Court of Cassation"],
        },
        societario: {
          title: "Corporate & M&A",
          desc: "Structured counsel for companies, founders and investors.",
          items: ["Mergers & acquisitions", "Shareholders' agreements", "Governance & bylaws", "Commercial transactions"],
        },
        immobiliare: {
          title: "Real Estate Law",
          desc: "End-to-end assistance on residential and strategic property transactions.",
          items: ["Sales & leases", "Condominium disputes", "Planning permissions", "Due diligence"],
        },
        crediti: {
          title: "Debt Recovery & Enforcement",
          desc: "Fast, effective strategies to protect your credit, also across borders.",
          items: ["Injunctions", "Enforcement & seizures", "Opposition proceedings", "Settlement agreements"],
        },
        patrimonio: {
          title: "Asset Protection",
          desc: "Legal architecture designed to preserve family and business wealth.",
          items: ["Foundations & trusts", "Family pacts", "Succession planning", "Asset protection"],
        },
      },
    },
    studio: {
      overline: "The Firm",
      title: "Excellence is born from listening.",
      p1: "Legalia Società tra Avvocati is an association of lawyers based in Manduria, in the province of Taranto. We work throughout Italy, standing beside individuals and businesses on the basis of a simple principle: behind every case there is a person, or a company, in need of certainty. That is why we build strategy around your goal, not around formalities.",
      p2: "A small, hand-picked team, professionals who personally follow every assignment and a network of correspondents across Italy: the structure of a boutique, the capability of an established practice.",
      values: [
        { title: "Transparency", desc: "Every fee, every timeline, every risk: clear from the start, with no surprises." },
        { title: "Professional ethics", desc: "Absolute confidentiality and ethical rigour as the non-negotiable foundation of our work." },
        { title: "Determination", desc: "Every case is personally followed by the firm's lawyers, with negotiation and courtroom effectiveness." },
      ],
      stripLabel: "The firm's equity partners",
    },
    team: {
      overline: "Our people",
      title: "The Firm's Team",
      intro: "Three equity partners, three partners and two secretaries: one single direction, the rigorous protection of the interests of those who turn to us.",
      competenze: "Areas of expertise",
      attivita: "Activities",
      roles: { Socio: "Equity Partner", Partner: "Partner", Segreteria: "Secretariat" },
      contact: "Write to the Firm",
      members: {
        "giuseppe-brunetti": {
          items: ["Criminal law", "Family law", "Successions"],
          bio: "For twenty-five years he has practised family and criminal law, as well as successions and family pacts.",
        },
        "vincenzo-simone-depasquale": {
          items: ["Labour law", "Tax & fiscal law"],
          bio: "Former director of a leading agri-food business group, he heads the real estate, tax, fiscal and employment departments, assisting individuals and companies also in analysing balance sheets and in relations with suppliers and employees.",
        },
        "francesco-del-prete": {
          items: ["Banking & financial law", "Pension law"],
          bio: "An expert in banking and financial law, he assists individuals and businesses; he is also an expert in public pension law, assisting applicants in obtaining service-related recognition and the resulting benefits.",
        },
        "michela-sansonetti": {
          items: ["Debt recovery", "Civil liability"],
        },
        "marika-antonucci": {
          items: ["Banking law", "Personal injury"],
        },
        "valeria-mustica": {
          items: ["Condominium law", "Asset protection"],
        },
        "luisiana-forleo": {
          items: ["Secretariat", "Client relations", "Case-file preparation"],
        },
        "eleonora-calo": {
          items: ["Secretariat", "Client relations", "Case-file preparation"],
        },
      },
    },
    metodo: {
      overline: "Our method",
      title: "A clear path, from listening to resolution.",
      steps: [
        { title: "Listening & assessment", desc: "A first, no-commitment meeting: we analyse your position, your documents and your goals." },
        { title: "Tailor-made strategy", desc: "We transparently define the plan of action, the timing, the costs and the chances of success." },
        { title: "Action & negotiation", desc: "Legal action or direct negotiation: we choose the most efficient path to the result, always personally handled by the firm's lawyers." },
        { title: "Monitoring & resolution", desc: "Constant, transparent updates until the solution — judicial or out-of-court — is reached." },
      ],
    },
    news: {
      overline: "Legal news",
      title: "Legal updates",
      intro: "The firm's analysis of rules, reforms and rulings affecting individuals and businesses.",
      readMore: "Read the update",
      empty: "The firm's legal updates are coming soon.",
      emptyHint: "We are preparing our first articles: check back soon.",
    },
    sede: {
      overline: "Our offices",
      title: "The Salone",
      text: "A historic hall in the heart of Manduria, where every case is discussed face to face with the lawyer who follows it.",
      caption: "Piazza Vittorio Emanuele II, 20/c · Manduria (TA)",
      cta: "Come and meet us",
      galleryLabel: "Views of our land",
      gallery: [
        "Mother Church · Piazza Vittorio Emanuele II",
        "War Memorial",
        "Piazza Garibaldi",
        "Municipal Villa",
        "Dunes of the Coast",
        "Messapian Walls",
      ],
    },
    contatti: {
      overline: "Contact",
      title: "Let's talk.",
      intro: "The first meeting is free of any commitment and helps us understand whether we are the right firm for you. Book an appointment: you will receive a summary email and we will confirm the date as soon as possible.",
      labels: { studio: "Office", phone: "Phone", whatsapp: "WhatsApp", emailpec: "Email / PEC", hours: "Hours" },
      areas: ["Civil & Family Law", "Criminal Law", "Corporate & M&A", "Real Estate Law", "Debt Recovery & Enforcement", "Asset Protection", "Other"],
      form: {
        nome: "Full name *",
        nomePh: "Jane Doe",
        email: "Email *",
        emailPh: "jane.doe@email.com",
        telefono: "Phone",
        telefonoPh: "+39 ...",
        area: "Area of interest *",
        areaPh: "Select…",
        data: "Preferred date *",
        ora: "Preferred time *",
        messaggio: "Message *",
        messaggioPh: "Briefly describe your case: it will be treated as confidential.",
        privacyA: "privacy policy",
        privacyPre: "I have read the ",
        privacyPost: " and I consent to the processing of my personal data under Regulation (EU) 2016/679 (GDPR). *",
        submit: "Book the appointment",
        sending: "Sending…",
      },
      errors: {
        nome: "Please enter your name",
        email: "Please enter a valid email address",
        area: "Please select an area",
        data: "Please choose a date",
        dataWeekend: "The firm receives from Monday to Friday",
        ora: "Please choose a time",
        messaggio: "Briefly tell us about your case (min. 10 characters)",
        consenso: "You must accept the privacy policy",
      },
      toasts: {
        checkTitle: "Please check the highlighted fields",
        checkDesc: "Some information is missing or invalid.",
        okTitle: "Request sent successfully",
        okDesc: "We have sent you a summary email: we will contact you to confirm the appointment.",
        failTitle: "Sending failed",
        failDesc: "Please try again shortly or write to us by certified email (PEC).",
        failDescFix: "Please correct and try again.",
      },
    },
    footer: {
      about: "An association of lawyers based in Manduria (TA): legal counsel in civil, criminal, corporate and real estate matters.",
      nav: "Navigation",
      contatti: "Contact",
      legal: "All rights reserved. The information on this website is purely for information purposes and does not constitute legal advice.",
      privacy: "Privacy Policy",
      admin: "Appointment Management",
    },
    privacy: {
      overline: "Public notice",
      title: "Privacy Policy",
      back: "Back to Home",
      updated: "Information on the processing of personal data pursuant to Regulation (EU) 2016/679 (GDPR) · Last updated: 30 September 2026",
      sections: [
        { title: "1. Data controller", body: ["The data controller is Legalia Società tra Avvocati, with registered office at Piazza Vittorio Emanuele II, 20/c · 74024 Manduria (TA), VAT 03451670735, certified email legalia@pec.it (the \"Controller\")."] },
        { title: "2. Data processed", body: ["Through the contact form on this website we collect the following personal data provided voluntarily by the data subject: name and surname, email address, telephone number (optional), area of interest, requested appointment date and time, and the content of the message.", "No special categories of data within the meaning of Art. 9 of Regulation (EU) 2016/679 are processed, nor any browsing data other than technical cookies."] },
        { title: "3. Purposes and legal basis", body: ["Data is processed exclusively to respond to requests for contact, information and advice submitted through the form on this website, as well as to send a reminder of the confirmed appointment.", "The legal basis for processing is the performance of pre-contractual measures at the request of the data subject (Art. 6(1)(b) of Regulation (EU) 2016/679).", "Providing data is optional but necessary in order to handle your request: without the data marked as mandatory we will not be able to reply."] },
        { title: "4. Method of processing and retention", body: ["Data is processed using IT tools, in accordance with the principles of fairness, lawfulness and transparency and in compliance with the minimum security measures set out in Art. 32 of the Regulation.", "Data is retained for the time strictly necessary to handle the request received and, in any case, no longer than the period provided for by applicable law; the data subject may request its deletion at any time."] },
        { title: "5. Communication and disclosure of data", body: ["The data collected is not disclosed and is not transferred to third parties for marketing purposes. It is accessible only to persons authorised by the Controller and may be communicated where provided for by law.", "To handle the requests received, data may be forwarded by email to the Controller's email address indicated in point 1."] },
        { title: "6. Rights of the data subject", body: ["The data subject may exercise at any time the rights provided for by Arts. 15-22 of Regulation (EU) 2016/679: access, rectification, erasure, restriction of processing, data portability, and objection to processing.", "The data subject also has the right to lodge a complaint with the Italian Data Protection Authority (Garante per la protezione dei dati personali, www.garanteprivacy.it), should they believe that the processing of their data breaches the Regulation."] },
        { title: "7. Contacts", body: ["To exercise your rights or for any request regarding the protection of personal data, you may contact the Controller by writing to the certified email (PEC) legalia@pec.it or to the email address studiobdlex@gmail.com."] },
        { title: "8. Cookies", body: ["This website uses only technical cookies, which are necessary for the pages to work properly. No profiling cookies or third-party tracking tools are used."] },
        { title: "9. Legal notice", body: ["The information contained in this website is purely for information purposes and does not constitute legal advice, nor does it create any professional relationship with the user."] },
      ],
    },
  },
};
